import { getUrlQueryParam } from "./util/params";
import {
  loadSpin,
  loadUrl,
  setNotification,
  updateSpinInfoHotspots,
} from "./redux";
import { allowedParentOrigins } from "./config";
import { getEditorData, getHotspotsObject } from "./redux/selectors";
import { Alert } from "@material-ui/lab";
import { sendToParent } from "./apis/postMessage";
import { callOnValueChangeFactory } from "./util/general";
import { onModifiedChange } from "./onModifiedChange";
import { validateSirvUrl } from "./util/validateSirvUrl";

const hotspotEditorActions = {
  getHotspots: "getHotspots",
  setSpinData: "setSpinData",
  setSaveStatus: "setSaveStatus",
};

const parentActions = {
  load: "load",
  save: "save",
  setState: "setState",
};

const devtoolsMessageSources = [
  "react-devtools-bridge",
  "react-devtools-detector",
  "react-devtools-content-script",
  "@devtools-page",
  "@devtools-extension",
];

export const enableEmbeddedIO = (store) => {
  // I/O for when embedded via iframe
  const notifyParentIfIsModifiedChanged = callOnValueChangeFactory(
    (isModified) => {
      sendToParent(parentActions.setState, { isModified });
    },
    false
  );
  onModifiedChange(store, notifyParentIfIsModifiedChanged);
  window.addEventListener("message", (event) => {
    if (!allowedParentOrigins.includes(event.origin)) {
      console.warn(
        `HSE has received a message from ${event.origin} which is not in origin whitelist!`
      );
      return;
    }
    const { action, payload } = event.data;
    switch (action) {
      case hotspotEditorActions.getHotspots:
        sendToParent(parentActions.save, {
          hotspots: getHotspotsObject(store.getState()),
          editorData: getEditorData(store.getState()),
        });
        break;
      case hotspotEditorActions.setSpinData:
        const { spinURL, folderURL, layers, hotspots, editorData } = payload;
        let urlValid = false;
        validateSirvUrl(
          undefined,
          spinURL,
          (err) => (urlValid = err ? false : true)
        );
        if (urlValid) {
          store.dispatch(loadUrl(spinURL));
          break;
        }
        store.dispatch(
          //spinURL is not valid -- fallback to other data
          loadSpin({
            folderURL,
            info: {
              layers,
              settings: {
                hotspots,
              },
            },
            editorData,
          })
        );
        break;
      case hotspotEditorActions.setSaveStatus:
        const { success } = payload;
        if (success) {
          store.dispatch(updateSpinInfoHotspots());
        } else {
          store.dispatch(
            setNotification({
              message: "Couldn't save spin",
              children: <Alert severity="error">Couldn't save spin</Alert>,
            })
          );
        }
        break;
      default:
        if (devtoolsMessageSources.includes(event.data?.source)) {
          break;
        }
        if (["w-ready"].includes(event.data?.type)) {
          break; //something that happens when debugging from vscode
        }
        console.warn(
          `received unknown action type ${action}, event.data is printed below`
        );
        console.warn(event.data);
    }
  });

  const url = getUrlQueryParam();
  if (url) {
    store.dispatch(loadUrl(url));
  }
  window.addEventListener("load", () => {
    sendToParent(parentActions.load);
  });
};
